import { curry, prop, useWith } from "ramda";

export default curry((key, selector) => useWith(selector, [prop(key)]));
